import { useCallback } from 'react';
import { fetchPostData, fetchPostDataNew } from '@/Components/hooks/Api';

const useCurrentIncMasterReport = ({ setMultiImage, setRedactingData }) => {
    const getAgencyImg = useCallback((loginAgencyID) => {
        const val = { AgencyID: loginAgencyID };
        fetchPostData('Agency/GetDataAgencyPhoto', val).then((res) => {
            if (res) {
                const imgUrl = `data:image/png;base64,${res[0]?.Agency_Photo}`;
                setMultiImage(imgUrl);
            } else {
                console.log('errror');
            }
        });
    }, [setMultiImage]);

    const getAgencyWiseRedactingReport = useCallback(async (loginAgencyID, incID) => {
        const val = { AgencyID: loginAgencyID, IncidentID: incID };
        await fetchPostDataNew('CAD/RedactingofReports/GetAgencyWiseRedactingReport', val).then((data) => {
            if (data.length > 0) {
                setRedactingData(JSON.parse(data));
            } else {
                setRedactingData([]);
            }
        });
    }, [setRedactingData]);

    return {
        getAgencyImg,
        getAgencyWiseRedactingReport,
    };
};

export default useCurrentIncMasterReport;
